import { h } from 'preact';
import { ROUTE, ROUTE_SUFFIX } from 'src/common/constants';
import Button from 'src/components/button';
import * as styles from './styles.less';

interface SidebarNavigationProps {
    prefix?: 'chathost' | 'studio';
    isFrame?: boolean;
}
const LogonRegister = ({ isFrame, prefix = 'chathost' }: SidebarNavigationProps) => {
    const target = isFrame ? '_top' : undefined;

    return (
        <div class={styles.wrapper}>
            <Button href={`/${prefix}/${ROUTE_SUFFIX.LOGON}`} data-native={!!isFrame} target={target} appearance="login" fullwidth={true} testId={`logon-sidebar-${prefix}`}>
                Login
            </Button>
            <Button href={ROUTE.REGISTRATION} data-native={!!isFrame} target={target} appearance="register" fullwidth={true} testId={`register-sidebar-${prefix}`}>
                Register
            </Button>
        </div>
    );
};

export default LogonRegister;
